const GA4_MEASUREMENT_ID = import.meta.env.VITE_GOOGLE_ANALYTICS_ID;

export function getGA4ClientId(): Promise<string | null> {
	return new Promise((resolve) => {
		if (typeof window === 'undefined' || !window.gtag) {
			resolve(null);
			return;
		}
		try {
			window.gtag('get', GA4_MEASUREMENT_ID, 'client_id', (clientId: string) => {
				resolve(clientId);
			});
			// El login con Google await-ea esto ANTES de mandar el code, así que el
			// timeout se paga entero en el camino crítico. Con GA4 cargado el callback
			// vuelve en milisegundos; el timeout solo cubre el caso en que gtag quedó
			// como stub porque un bloqueador tumbó gtm.js, y ahí nunca va a resolver.
			setTimeout(() => resolve(null), 800);
		} catch {
			resolve(null);
		}
	});
}

export function setGA4UserId(userId: string | number): void {
	if (typeof window === 'undefined' || !window.gtag) return;
	window.gtag('config', GA4_MEASUREMENT_ID, {
		user_id: String(userId),
	});
}

export function trackGA4Event(
	eventName: string,
	params: Record<string, unknown> = {},
): void {
	if (typeof window === 'undefined' || !window.gtag) return;
	window.gtag('event', eventName, params);
}
